module.exports = __webpack_public_path__ + "img/preset2.d0ae2edd.png";